export default "/images/vendor/flag-icons/flags/1x1/cr.svg?96cca3298724eeac307f21cb4ddae43d";